import Switch from '@mui/material/Switch';

export default function AppSwitchSwitch({ onChange, checked, title, disabled = false }) {
    return (
        <Switch
            onChange={(event) => onChange(title, event)}
            checked={checked}
            disabled={disabled}
        />
    )
}
